<template>
  <div class="nuxt_container">
    <ApplicationErrorAlert />
    <slot />
    <dev-mark />
  </div>
</template>
